import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { AppContext } from 'store/AppContext';
import { getSveitarfelog } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function SveitarfelagFilter(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { setFilters } = props;
  const [sveitarfelogList, setSveitarfelogList] = useState([]);
  const [sveitarfelagsnumer, setSveitarfelagsnumer] = useState('');

  useEffect(() => {
    async function fetchSveitarfelog() {
      const { data, isSuccess, error } = await getSveitarfelog(context, []);
      
      if (isSuccess) {
        setSveitarfelogList(data);
      } else {
        console.error(error);
      }
    };

    fetchSveitarfelog();
  }, [context]);

  const handleSveitarfelagsnumerChange = event => {
    setSveitarfelagsnumer(event.target.value);

    setFilters(state => ({
      ...state,
      sveitarfelagsnumer: event.target.value
    }));
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="filters-sveitarfelag-select" shrink>
          Sveitarfélag
        </InputLabel>
        <Select
          labelId="filters-sveitarfelag-select-label"
          id="filters-sveitarfelag-select"
          value={sveitarfelagsnumer}
          displayEmpty={true}
          onChange={handleSveitarfelagsnumerChange}
        >
          <MenuItem value="">
            <em>Öll sveitarfélög</em>
          </MenuItem>
          {sveitarfelogList.map((s) => (
            <MenuItem key={s.sveitarfelagsnumer} value={s.sveitarfelagsnumer}>
              {s.nafn}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}